import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'
import { SendTestsMessageForm } from './common/SendTestsMessageForm/SendTestsMessageForm'
import { SendTestsMessageHeader } from './common/SendTestsMessageHeader/SendTestsMessageHeader'

import { useSendTestsMessageModalState } from './hooks'

import styles from './SendTestsMessageModal.module.scss'

export const SendTestsMessageModal = ({
  candidates,
  deadline,
  subtitle,
  title,
  name,
  type,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  mode,
  isExtending = false,
}) => {
  const { state, handlers } = useSendTestsMessageModalState(
    { candidates, name, deadline, isOpen },
    { onCancel, onClose, onConfirm },
    mode,
  )

  const {
    activeStep,
    currentStepIndex,
    form: { control, formState },
    steps,
    isConfirmationOpen,
    isFirstStep,
    isLastStep,
  } = state
  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleNextStep,
    handlePreviousStep,
  } = handlers

  return (
    <>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Send`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ title, isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <SendTestsMessageHeader
            onNextStep={handleNextStep}
            onPreviousStep={handlePreviousStep}
            {...{ currentStepIndex, steps, subtitle, isFirstStep, isLastStep }}
          />
          <MessageAlert
            className={styles.alert}
            message={t`Language of the message depends on the candidate's preferred language.`}
            variant="info"
            isInitialised
          />
          {isExtending ? (
            <MessageAlert
              className={styles.alert}
              message={t`At least one of these candidates is past their deadline. Sending will extend their deadline to the date below.`}
              variant="warning"
              isInitialised
            />
          ) : null}
          <SendTestsMessageForm
            key={activeStep}
            {...{ control, currentStepIndex, formState, type }}
          />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
